import React from 'react'
import classNames from 'classnames/bind'
import { BadgeColor } from 'components/Badge'
import LabelBadge, { LabelBadgeProps } from '../LabelBadge/LabelBadge'
import { ProductBadge } from 'types/Product'
import { BuyerRequestStatus } from 'types/PricingRequest'
import {
  ProductBadgeEnum,
  PricingRequestStatusEnum,
  RepPricingRequestStatusEnum
} from '../../../__generated__/globalTypes'

import styles from './LabelBadgeList.module.css'

const cx = classNames.bind(styles)

export type LabelBadgeListProps = {
  className?: string
  color?: BadgeColor | undefined
  ids:
    | ProductBadge[]
    | ProductBadgeEnum[]
    | PricingRequestStatusEnum[]
    | RepPricingRequestStatusEnum[]
    | BuyerRequestStatus[]
    | null

  onDismissClick?: (
    option:
      | ProductBadge
      | ProductBadgeEnum
      | PricingRequestStatusEnum
      | RepPricingRequestStatusEnum
      | BuyerRequestStatus,
    index: number
  ) => void
} & Omit<LabelBadgeProps, 'id' | 'onDismissClick'>

const LabelBadgeList = ({ className, ids, style, onDismissClick, ...props }: LabelBadgeListProps) => {
  return (
    <div className={cx(styles.labelBadgeListContainer, className)}>
      {ids?.map((option, index) => (
        <LabelBadge
          key={index}
          id={option}
          style={style}
          onDismissClick={() => {
            onDismissClick?.(option, index)
          }}
          {...props}
        />
      ))}
    </div>
  )
}

export default LabelBadgeList
